/* eslint no-extend-native: 0 */
// core-js comes with Next.js. So, you can import it like below
import includes from 'core-js/stable/string/virtual/includes';
import repeat from 'core-js/stable/string/virtual/repeat';
import assign from 'core-js/stable/object/assign';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

String.prototype.endsWith = function (pattern) {
  const l = this.length - pattern.length;
  return l >= 0 && this.lastIndexOf(pattern) === l;
};

String.prototype.includes = includes;
String.prototype.repeat = repeat;
Object.assign = assign;
